const NEO_HUB_LABEL = 'hubn';

// Classic hub and neohub live on sibling subdomains: hub.narvar.com ->
// hubn.narvar.com. Rewrite only a leading `hub` host label, bounded by the end
// of that label, so preview hosts (hub-pr-123.qa20.narvar.qa) and bare hosts
// with a port (hub:3000) still rewrite, while these are returned untouched:
// origins already on neohub (hubn.narvar.com), labels that merely start with
// "hub" (hubspot.example.com, hubstage.qa20.narvar.qa), hosts carrying "hub"
// further along (myhub.example.com), and origins with no hub label at all.
//
// TODO: drive this from configuration once neohub has its own DNS entry. Note
// that a bare `process.env` read will not work: the browser bundle only sees
// variables listed in tools/webpack.config.js's DefinePlugin GLOBALS, so the
// variable has to be threaded through there as well.
const CLASSIC_HUB_LABEL = /^(https?:\/\/)hub(?=[.:-]|$)/;

export default () =>
  window.location.origin.replace(CLASSIC_HUB_LABEL, `$1${NEO_HUB_LABEL}`);
